module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// D:/发行部门文件/后台管理系统文件/~/core-js/library/modules/_add-to-unscopables.js
// module id = 277
// module chunks = 0